import { IconTab } from "@/src/components/iconTab";
import { uid } from "@/src/utils/utils";
import { useState } from "react";

export default function CalendarViewType({
  current,
  onChange,
}: {
  current: "day" | "week" | "month";
  onChange: (newValue: "day" | "week" | "month") => void;
}) {
  const [tabId, setTabId] = useState(current);
  return (
    <div className="c3 gap10">
        <div></div>
      <IconTab
        key={uid()}
        activeTabId={tabId}
        id="day"
        name="Jour"
        onChange={() => {
          setTabId("day");
          onChange("day");
        }}
      ></IconTab>
      <IconTab
        key={uid()}
        activeTabId={tabId}
        id="week"
        name="Semaine"
        onChange={() => {
          setTabId("week");
          onChange("week");
        }}
      ></IconTab>
    </div>
  );
}
